export default "__VITE_ASSET__D7wOYDWc__"